export default __webpack_public_path__ + "images/0xd5954c3084a1ccd70b4da011e67760b8e78aee84.png";